import { ReactNode } from 'react';
import { NoDataStateIcon } from 'assets/icons';
import { StateInfoBase } from '../StateInfoBase/StateInfoBase';

export type EmptyDisplayProps = {
    emptyInfo?: string;
    emptyAdditionalInfo?: string;
    emptyIcon?: ReactNode;
    className?: string;
};

export const EmptyDisplay = ({
    emptyInfo,
    emptyAdditionalInfo,
    emptyIcon = <NoDataStateIcon />,
    className,
}: EmptyDisplayProps) => (
    <StateInfoBase
        title={emptyInfo}
        subTitle={emptyAdditionalInfo}
        icon={emptyIcon}
        className={className}
    />
);
